import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ConfirmState {
    key: string;
}

const initialState: ConfirmState = {
    key: '',
};

const confirmSlice = createSlice({
    name: 'confirm',
    initialState,
    reducers: {
        setKey: (state, action: PayloadAction<string>) => {
            state.key = action.payload;
        },
    },
});

export const { actions: confirmActions } = confirmSlice;
export const { reducer: confirmReducer } = confirmSlice;